(function($) {

	$.fn.msxibrowser = function() {

        var $this = $(this);
        $this.addClass($.browser.name);
        $this.addClass($.browser.className);
        $this.addClass($.browser.platform);
        $this.addClass($.browser.layout);
	};

})(jQuery);